import { useCallback } from 'react';

import { App, AppIds } from '@cccom/config/app-type';
import { useGlobalStore } from '@cccom/config/global-store';

import {
  useAppsList,
  useHelpCenter,
  useValidateRoles,
  useWizardSettings,
} from '../api';

type SettingsState = {
  timezone: string;
  helpCenterUrl: string;
  appList: App[];
  wizardSettings: { skip: boolean };
  hasValidRoles: boolean;
  isAppActive: (appId: AppIds) => boolean;
  lastAccessedApp?: App;
};

export function useSettings(): SettingsState {
  const currentSite = useGlobalStore((state) => state.currentSite);
  const { data: helpCenter } = useHelpCenter();
  const { data: appList } = useAppsList();
  const { data: wizardSettings } = useWizardSettings();
  const { data: validateRoles } = useValidateRoles(
    appList?.lastAccessed?.id || 'HOME'
  );

  const isAppActive = useCallback(
    (appId: AppIds) => !!appList?.apps.find((app) => app.id === appId),
    [appList]
  );

  const settings: SettingsState = {
    timezone: currentSite?.timezone ?? 'UTC',
    helpCenterUrl: helpCenter?.url ?? '',
    appList: appList?.apps ?? [],
    lastAccessedApp: appList?.lastAccessed,
    wizardSettings: wizardSettings ?? { skip: false },
    hasValidRoles: validateRoles?.hasValidRoles ?? true,
    isAppActive,
  };

  return settings;
}
